import axios from 'axios';

/**
 * Service for user management and authentication information
 */

// Get current user information from authentication status
export async function getCurrentUser() {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      return null;
    }

    const response = await axios.get('/auth/status', {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (response.data && response.data.authenticated) {
      return {
        username: response.data.username,
        role: response.data.role,
        user_id: response.data.user_id,
        authenticated: true
      };
    }

    return null;
  } catch (error) {
    console.error('Error getting current user:', error);
    return null;
  }
}

// Check if current user is admin
export async function isAdmin() {
  try {
    const user = await getCurrentUser();
    return user && user.role === 'admin';
  } catch (error) {
    console.error('Error checking admin status:', error);
    return false;
  }
}

// Get all WEB_DASHBOARD users (admin only)
export async function getWebDashboardUsers() {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token');
    }

    const response = await axios.get('/auth/users', {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    return response.data;
  } catch (error) {
    console.error('Error getting web dashboard users:', error);
    throw error;
  }
}

// Create new WEB_DASHBOARD user (admin only)
export async function createWebDashboardUser(username, password, role = 'user') {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token');
    }

    const response = await axios.post('/auth/users', 
      {
        username,
        password,
        role
      },
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error creating web dashboard user:', error);
    throw error;
  }
}

// Deactivate WEB_DASHBOARD user (admin only)
export async function deactivateWebDashboardUser(username) {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token');
    }

    const response = await axios.delete(`/auth/users/${username}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    return response.data;
  } catch (error) {
    console.error('Error deactivating web dashboard user:', error);
    throw error;
  }
}
